import { seloFechamentoAPI } from './API/SeloFechamentoAPI';
import { atualUfDefinition } from '@/helpers/utils';

export default {
  data: () => ({ visibilidadeFechamento: null }),
  computed: {
    fechamento2026Ativo() { return this.isSala && this.config && this.config.fechamentoSelo === true; },
    chaveVisibilidadeFechamento() {
      const params = this.$route.params;
      const id = params.municipioId || params.id || this.cityId;
      return this.fechamento2026Ativo && id ? `${atualUfDefinition.uf}:${id}` : null;
    },
  },
  watch: {
    chaveVisibilidadeFechamento: {
      immediate: true,
      async handler(chave) {
        this.visibilidadeFechamento = null;
        if (!chave) return;
        const [uf, id] = chave.split(':');
        try {
          const { data } = await seloFechamentoAPI.visibilidadeMunicipio(uf, 2026, id);
          if (this.chaveVisibilidadeFechamento === chave) this.visibilidadeFechamento = data;
        } catch (_) {
          // Não recuperar permissões de resultados antigos em caso de recusa.
        }
      },
    },
  },
};
